function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M0 4.0023C0 1.7964 1.82722 0 4.07208 0H8.53708C10.7774 0 12.6 1.791 12.6 3.9933V13.9977C12.6 16.2045 10.7728 18 8.527 18H4.06384C1.82264 18 0 16.209 0 14.0067V13.1607V4.0023Z",
  fill: "#FFDD02"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M17.8011 8.50931L15.2399 5.89121C14.9752 5.62121 14.5492 5.62121 14.2854 5.89301C14.0224 6.16481 14.0233 6.60311 14.2871 6.87311L15.6904 8.30681H14.345H6.7937C6.42118 8.30681 6.11877 8.61731 6.11877 8.99981C6.11877 9.38321 6.42118 9.69281 6.7937 9.69281H15.6904L14.2871 11.1265C14.0233 11.3965 14.0224 11.8348 14.2854 12.1066C14.4177 12.2425 14.5904 12.3109 14.764 12.3109C14.9358 12.3109 15.1084 12.2425 15.2399 12.1084L17.8011 9.49121C17.9282 9.36071 18.0001 9.18431 18.0001 8.99981C18.0001 8.81621 17.9282 8.63981 17.8011 8.50931Z",
  fill: "white"
});

var SvgLogout = function SvgLogout(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLogout, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Logout.581cf996.svg";
export { ForwardRef as ReactComponent };